export function initTabs() {
    const tabsComponents = document.querySelectorAll('.tabs');

    tabsComponents.forEach(tabs => {
        const navItems = tabs.querySelectorAll('.tabs__nav__item');
        const panels = tabs.querySelectorAll('.tabs__panel');
        const indicator = tabs.querySelector('.tabs__indicator');
        const nav = tabs.querySelector('.tabs__nav');

        let indicatorRafId = null;
        let resizeRafId = null;

        const isVerticalLayout = () => {
            if (!nav) return false;
            return window.getComputedStyle(nav).flexDirection === 'column';
        };

        const updateIndicator = (activeItem) => {
            if (!indicator || !activeItem || !nav) return;

            if (indicatorRafId) {
                cancelAnimationFrame(indicatorRafId);
            }

            indicatorRafId = requestAnimationFrame(() => {
                const navRect = nav.getBoundingClientRect();
                const itemRect = activeItem.getBoundingClientRect();
                const isVertical = isVerticalLayout();

                if (isVertical) {
                    indicator.style.width = '3px';
                    indicator.style.height = `${itemRect.height}px`;
                    indicator.style.left = '0';
                    indicator.style.top = '0';
                    indicator.style.transform = `translate3d(0, ${itemRect.top - navRect.top}px, 0)`;
                } else {
                    indicator.style.height = '2px';
                    indicator.style.width = `${itemRect.width}px`;
                    indicator.style.left = '0';
                    indicator.style.top = 'calc(100% - 1px)';
                    indicator.style.transform = `translate3d(${itemRect.left - navRect.left}px, 0, 0)`;
                }
            });
        };

        const handleTabClick = (e, item) => {
            e.preventDefault();
            const link = item.querySelector('.tabs__nav__link');
            const targetId = link.getAttribute('href');
            const targetPanel = tabs.querySelector(targetId);

            if (!targetPanel) return;

            // Remove active classes
            navItems.forEach(navItem => navItem.classList.remove('tabs__nav__item--active'));
            panels.forEach(panel => panel.classList.remove('tabs__panel--active'));

            // Add active classes
            item.classList.add('tabs__nav__item--active');
            targetPanel.classList.add('tabs__panel--active');

            // Update indicator
            updateIndicator(item);
        };

        // Attach events
        navItems.forEach(item => {
            item.addEventListener('click', (e) => handleTabClick(e, item));
        });

        // Initialize indicator position
        const activeItem = tabs.querySelector('.tabs__nav__item--active') || navItems[0];
        if (activeItem) {
            requestAnimationFrame(() => {
                updateIndicator(activeItem);
            });
        }

        // On window resize update indicator
        window.addEventListener('resize', () => {
            if (resizeRafId) {
                cancelAnimationFrame(resizeRafId);
            }

            resizeRafId = requestAnimationFrame(() => {
            const currentActive = tabs.querySelector('.tabs__nav__item--active');
            updateIndicator(currentActive);
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', initTabs);
